// Scroll effects. Scroll-linked reveals: every [data-nv-reveal] element gets --nv-in: 0 while its top is
// at the bottom of the screen, rising to 1 as it reaches the upper part. Sections turn
// that into their own entrance. data-nv-reveal-end moves the finish line (share of screen height).
(function () {
  if (window.nvRevealReady) return;
  window.nvRevealReady = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var items = [];
  var frame = null;

  var update = function () {
    frame = null;
    var viewport = window.innerHeight;
    items.forEach(function (item) {
      var progress = 1;
      if (!reducedMotion.matches) {
        var end = viewport * (parseFloat(item.dataset.nvRevealEnd) || 0.45);
        var top = item.getBoundingClientRect().top;
        progress = Math.max(0, Math.min(1, (viewport - top) / (viewport - end)));
      }
      var value = progress.toFixed(3);
      if (item.dataset.nvInValue === value) return;
      item.dataset.nvInValue = value;
      item.style.setProperty('--nv-in', value);
    });
  };
  var request = function () {
    if (!frame) frame = requestAnimationFrame(update);
  };
  // One-shot entrances: [data-nv-appear] gets .is-in once it comes into view; CSS animates it.
  // The html class lets CSS hide those blocks only once this script is running.
  document.documentElement.classList.add('nv-appear');
  var appearObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              appearObserver.unobserve(entry.target);
            });
          },
          // Fires as a block's top passes 88% of the screen, however tall the block is.
          { threshold: 0, rootMargin: '0px 0px -12% 0px' }
        )
      : null;
  var designMode = window.Shopify && window.Shopify.designMode;
  var watchAppear = function () {
    document.querySelectorAll('[data-nv-appear]:not(.is-in)').forEach(function (block) {
      // Number the parts so they follow one another, capped so long grids don't drag.
      block.querySelectorAll('.nv-rise').forEach(function (part, index) {
        if (!part.style.getPropertyValue('--nv-order')) part.style.setProperty('--nv-order', Math.min(index, 8));
      });
      // The theme editor shows everything in place so merchants aren't editing hidden content.
      if (!appearObserver || reducedMotion.matches || designMode) {
        block.classList.add('is-in');
      } else {
        appearObserver.observe(block);
      }
    });
  };

  var collect = function () {
    items = Array.prototype.slice.call(document.querySelectorAll('[data-nv-reveal]'));
    watchAppear();
    request();
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  document.addEventListener('shopify:section:load', collect);
  collect();
})();
